import React, { useState, useEffect } from "react";
import io from "socket.io-client";
import {
  Container,
  MapContainer,
  ContentContainer,
  LoadingContainer,
} from "./MapPageStyle";
import Footer from "../../components/Footer/Footer";
import PageHeader from "../../components/TopHeader/PageHeader";
import GroupSelectForm from "../../components/Form/CategorySelectForm";
import MonitoringMap from "../../components/Map/MonitoringMap";
import Seo from "../../components/Seo";
import requiredAuth from "../../components/requiredAuth";
import { SOCKET_URL } from "../../constants";
import { useRecoilValue } from "recoil";
import { accessTokenAtom } from "../../recoil/auth";
import RealTimeDeviceTable from "../../components/Table/RealTimeDeviceTable";
import { selectedCategoryAtom } from "../../recoil";
import { useQuery } from "@tanstack/react-query";
import { getDevices } from "../../apis/api/Device/getDevices";
import { useTranslation } from "react-i18next";

function MapPage() {
  const [filteredData, setFilteredData] = useState([]);
  const [sortedData, setSortedData] = useState(filteredData);
  const [isGeoShow, setIsGeoShow] = useState(false);
  const [isGeoAlert, setIsGeoAlert] = useState(false);
  const selectedCategory = useRecoilValue(selectedCategoryAtom);
  const accessToken = useRecoilValue(accessTokenAtom);

  const { data: deviceData } = useQuery({
    queryKey: ["devices"],
    queryFn: () => getDevices(accessToken),
  });

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const socket = io(`${SOCKET_URL}`, {
      transports: ["websocket"],
      auth: {
        accessToken: accessToken,
      },
    });
    socket.on("real_time_device", (data) => {
      const parsedData = typeof data === "string" ? JSON.parse(data) : data;
      const newData = { };
      Object.keys(parsedData).forEach((key) => {
          const dataObject = parsedData[key];
          dataObject.lat = parseFloat(dataObject.lat);
          dataObject.lon = parseFloat(dataObject.lon);
          dataObject.alt = parseFloat(dataObject.alt);
          dataObject.geoidal = parseFloat(dataObject.geoidal);
          dataObject.velocity = parseFloat(dataObject.speed);
          dataObject.serial = key;

          newData[key] = dataObject;
      });

        const filteredDataArray = Object.values(newData).filter(
          (device) => device.serial
        );
        setFilteredData(filteredDataArray);

        console.log("==newData==");
        console.log(newData);
        console.log("===========");
        return newData;
      });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    const sortData = () => {
      if (selectedCategory && selectedCategory.length > 0) {
        const selected = selectedCategory[0].toLowerCase();

        return filteredData
          .filter((realtimeDevice) => {
            const isLPGA = realtimeDevice.isLPGA === true;

            // 유저가 설정한 category가 존재하면 그대로 사용
            const rawCategory = realtimeDevice.category;
            const category = rawCategory?.toLowerCase?.();

            if (isLPGA) {
              // LPGA 장치: category 없으면 "default"
              const normalizedCategory = category || "default";
              return normalizedCategory === selected;
            } else {
              // 비-LPGA 장치
              if (!category || category === "") {
                // 설정된 category 없으면 "unnamed"
                return selected === "unnamed";
              } else {
                // category가 있다면 그 값으로 필터
                return category === selected;
              }
            }
          })
          .sort((a, b) => {
            const qualityA = a.quality?.toLowerCase().trim();
            const qualityB = b.quality?.toLowerCase().trim();
            if (qualityA === "off" && qualityB !== "off") return 1;
            if (qualityA !== "off" && qualityB === "off") return -1;
            return 0;
          });
      }

      // 카테고리 선택이 없을 경우
      return filteredData
        .sort((a, b) => {
          const qualityA = a.quality?.toLowerCase().trim();
          const qualityB = b.quality?.toLowerCase().trim();
          if (qualityA === "off" && qualityB !== "off") return 1;
          if (qualityA !== "off" && qualityB === "off") return -1;
          return 0;
        });
    };

    setSortedData([...sortData()]);
  }, [selectedCategory, deviceData, filteredData]);

  

  function nullFilter(data) {
    return data.filter((item) => item.lat !== null && item.lon !== null);
  }

  const [isGroupSelectFormVisible, setGroupSelectFormVisible] = useState(false);

  const handleFilterButtonClick = () => {
    setGroupSelectFormVisible(!isGroupSelectFormVisible);
  };

  const toggleGeoShow = () => {
    setIsGeoShow((prev) => !prev);
  };

  const toggleGeoAlert = () => {
    setIsGeoAlert((prev) => !prev);
  };

  return (
    <Container>
      <Seo title={t(`monitoring`)} />
      <PageHeader isHome={true} />
      <MapContainer>
        {/* {sortedData.length === 0 ? (
          <LoadingContainer>{t(`no device`)}</LoadingContainer>
        ) : ( */}
          <MonitoringMap
            socketData={nullFilter(sortedData)}
            isGeoShow={isGeoShow}
            isGeoAlert={isGeoAlert}
          />
        {/* )} */}
      </MapContainer>
      <GroupSelectForm
        setGroupSelectFormVisible={setGroupSelectFormVisible}
      />
      <ContentContainer>
        <RealTimeDeviceTable realtimeData={sortedData} />
      </ContentContainer>
      <Footer />
    </Container>
  );
}

export default requiredAuth(MapPage);
